const Cny = {
  symbol: 'cny',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM9.171 8v1.925h13.816V8zm-1.54 5.641v1.945h4.895v.385c-.079 1.886-.473 3.407-1.223 4.6-.75 1.08-2.171 2.003-4.303 2.735L8.105 25c2.21-.75 3.79-1.81 4.777-3.157 1.006-1.464 1.559-3.427 1.657-5.872v-.385h2.922v6.93c0 1.406.69 2.118 2.092 2.118h3.138c.69 0 1.204-.212 1.559-.597.355-.404.612-1.694.75-3.87l-1.855-.577c-.04 1.56-.138 2.503-.277 2.81-.118.29-.315.444-.552.444h-2.171c-.454 0-.671-.25-.671-.751v-6.507h5.23V13.64z" fill-rule="evenodd"/>`;
  },
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" fill="#ff4314" r="16"/><path d="M9.171 8h13.816v1.925H9.17zm-1.54 5.641h17.073v1.945h-5.23v6.507c0 .5.217.75.67.75h2.172c.237 0 .434-.153.552-.442.139-.308.237-1.252.277-2.811l1.855.578c-.138 2.175-.395 3.465-.75 3.87-.355.384-.868.596-1.56.596h-3.137c-1.402 0-2.092-.712-2.092-2.118v-6.93h-2.922v.385c-.098 2.445-.65 4.408-1.657 5.872-.987 1.347-2.566 2.406-4.777 3.157L7 23.306c2.132-.732 3.553-1.656 4.303-2.734.75-1.194 1.144-2.715 1.223-4.601v-.385H7.632z" fill="#fff"/></g>`;
  }
};
export default Cny;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/cny.js
// module id = null
// module chunks = 